import BtnFilled from '../../components/BtnFilled';
import { completeIntegration, deferIntegration } from '../../api/api';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useIntegrationsStore } from './state/use-integrations-store';
dayjs.extend(utc);

const ActionButtons = ({ isDeferred, deviceId, comment }) => {
  const { fetchIntegrations, closeModal } = useIntegrationsStore();

  const close = async () => {
    await fetchIntegrations();
    closeModal();
  };

  const handleSuccess = useCallback(async () => {
    const body = {
      ...(comment && { comment }),
      device_id: deviceId,
      done_at: dayjs.utc().toISOString(),
    };
    await completeIntegration({
      body,
      dataCb: () => {
        toast.success('Интеграция успешно выполнена!');
        close();
      },
      errCb: (err) => {
        toast.error(err.error ? err.error : 'Ошибка сервера при отправке интеграции', { hideProgressBar: false });
      },
    });
  }, [close, comment, deviceId]);

  const handleDefer = useCallback(async () => {
    const body = { ...(comment && { comment }), device_id: deviceId };
    await deferIntegration({
      body,
      dataCb: () => {
        toast.success('Интеграция отправлена на уточнение!');
        close();
      },
      errCb: (err) => {
        toast.error(err.error ? err.error : 'Ошибка сервера при отправке интеграции', { hideProgressBar: false });
      },
    });
  }, [close, comment, deviceId]);

  return (
    <>
      <BtnFilled btnCb={handleSuccess} title={'Выполнено'} className={'bg-orange-500 hover:bg-black'} />
      {!isDeferred && <BtnFilled disabled={!comment} btnCb={handleDefer} title={'Отправить на уточнение'} className={'bg-red-500 hover:bg-red-600 mt-3'} />}
    </>
  );
};

export default ActionButtons;
